import React, { Fragment } from 'react';
import Store from 'eas-react-store';
import { withTranslation } from 'react-i18next';
import Header from '../layout/Header/Header.jsx';
import CategoriesTableRow from '../../components/categories-table-row/CategoriesRow';
import { URI } from '../../URI'

class AdminCategories extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            categories: this.props.store.Category.data,
            isAddingNewCategory: false
        }
        
    }

    handleNewCategoryButton() {
        this.setState({
            isAddingNewCategory: !this.state.isAddingNewCategory,
        })
    }

    renderAddNewCategoryField() {
        if (this.state.isAddingNewCategory) {
            let newCat = {
                title: "",
                color: "8BC34A"
            };
            return(
                <CategoriesTableRow
                    category={newCat}
                    isEditMode={true}
                    hideNewCategoryField={this.handleNewCategoryButton.bind(this)}
                />
            )
        }
    }

    renderRows() {
        return this.state.categories.map((cat) => {
            return (
                <CategoriesTableRow
                    key={cat.id}
                    category={cat}
                    isEditMode={false}
                />
            )
        })
    }

    render() {
        return (
            <Fragment>
                <Header
                    current={URI.admin.categories}
                    currentRoot={URI.admin.root}
                />
                <div className="container content-container">
                    <div className="category-table-header mb-3">
                        <h1>{this.props.t('common.categories')}</h1>
                        <button
                            className="btn btn-primary btn-table add-user"
                            onClick={() => this.handleNewCategoryButton()}
                        >
                            {this.props.t('categories.add')}
                        </button>
                    </div>
                    <table className="categories-table">
                        <thead>
                            <tr>
                                <th>{this.props.t('common.name')}</th>
                                <th>{this.props.t('common.colour')}</th>
                                <th className="cell-right">{this.props.t('common.action')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}
                            {this.renderAddNewCategoryField()}
                        </tbody>
                    </table>
                </div>
            </Fragment>
        );
    }

}

export default Store.connectStore(withTranslation()(AdminCategories))